import { render, staticRenderFns } from "./CompanyTableAvatar.vue?vue&type=template&id=59cf7851&scoped=true"
import script from "./CompanyTableAvatar.vue?vue&type=script&lang=js"
export * from "./CompanyTableAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cf7851",
  null
  
)

export default component.exports